import { BLACK, TRANSPARENT, WHITE, BLACK_600 } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var ACTIVE_NAVIGATION_BUTTON_COLOR = BLACK_600;
export var getCarouselNavigationButtonStyles = props => {
  var disabled = props.disabled,
    theme = props.theme;
  var fill = theme != 'dark' ? BLACK : WHITE;
  var backgroundColor = theme != 'dark' ? BLACK : WHITE;
  var borderColor = theme != 'dark' ? BLACK : WHITE;
  return StyleSheet.create({
    container: {
      width: 26,
      height: 26,
      borderRadius: 20,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: disabled ? TRANSPARENT : backgroundColor,
      borderColor: disabled ? ACTIVE_NAVIGATION_BUTTON_COLOR : borderColor,
      borderWidth: disabled ? 1 : 0,
      fill: disabled ? ACTIVE_NAVIGATION_BUTTON_COLOR : fill
    }
  });
};